module.exports = __webpack_public_path__ + "img/ИФ-1(А)-019.0ed6603d.png";